import { useContext } from "react"
import { logoPath } from "src/config"
import jobContext from "src/context/jobContext"
import userContext from "src/context/userContext"

export default function Title({ title }) {
    const { job } = useContext(jobContext)

    return (
        <div className="m-auto text-center text-main-color font-bold flex flex-col justify-center gap-4 items-center">
            <img src={job.organization ? process.env.REACT_APP_API_URL + "/img/" + job.organization.logo : ""} className="w-[90px]" />
            <div className="flex items-center">
                <h4>‌ {title} ‌</h4>
                <span> - {job.organization ? job.organization.name : "جابونت"}</span>
            </div>
        </div>
    )
}